import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
// Imported by file rather than through the barrel, so core/auth and core/services do not import
// each other. See the matching note in workspace-context.service.ts.
import { WorkspaceContext } from 'app/core/services/workspace-context.service';

@Injectable({
  providedIn: 'root',
})
export class RoleRedirectGuard implements CanActivate {
  private readonly _router = inject(Router);
  private readonly _workspace = inject(WorkspaceContext);

  /**
   * Sends authenticated users to the start of their own workspace.
   *
   * The answer comes from WorkspaceContext rather than from a second reading of the roles:
   * when the two disagreed, this guard sent people somewhere WorkspaceGuard then bounced them
   * out of again.
   */
  canActivate(): UrlTree {
    return this._router.parseUrl(this._workspace.homeUrlOf(this._workspace.owned));
  }
}
